module.exports = __webpack_public_path__ + "assets/img/gamekit_switchaccount@2x.23bb410.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/icons/gamekit_switchaccount@2x.png
// module id = 8Tb4
// module chunks = 50